export const rules = function () {
    return {
      carNo: [
        { required: true, message: '请输入车牌号', trigger: ['blur', 'change'] },
      ],
      name1: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
      name2: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
      name3: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
      name4: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
      name5: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
      name6: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
      name7: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
      name8: [
        { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
      ],
    }
}

export default {}